import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Field } from "formik";
import { Input } from "components/bootstrap";
const DirectionOptions = styled.div`
  display: flex;

  div:first-child {
    margin-right: 5px;
  }
`;
const Direction = ({ groupingIndex }) => {
  const { t } = useTranslation("aggregation");
  return /* @__PURE__ */ React.createElement(Field, { name: `groupBy.groupings.${groupingIndex}.direction` }, ({ field: { name, value, onChange, onBlur }, meta: { error } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "group-by-direction",
      label: t("wizard_grouping.direction"),
      error,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-7"
    },
    /* @__PURE__ */ React.createElement(DirectionOptions, null, /* @__PURE__ */ React.createElement(
      Input,
      {
        checked: value === "row",
        formGroupClassName: "",
        id: name,
        label: t("wizard_grouping.row"),
        onBlur,
        onChange,
        type: "radio",
        value: "row"
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        checked: value === "column",
        formGroupClassName: "",
        id: name,
        label: t("wizard_grouping.column"),
        onBlur,
        onChange,
        type: "radio",
        value: "column"
      }
    ))
  ));
};
export default Direction;
